import { render } from "./HomeServices.vue?vue&type=template&id=5a514450&scoped=true"
import script from "./HomeServices.vue?vue&type=script&lang=js"
export * from "./HomeServices.vue?vue&type=script&lang=js"

import "./HomeServices.vue?vue&type=style&index=0&id=5a514450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a514450"]])

export default __exports__